<template>
  <b-container fluid>
    <portal-navbar></portal-navbar>
    <b-modal hide-footer title="Verify Mobile" ref="mdlOtp" id="mdlOtp">
      <otp-verify @verified="LoadSurvey"></otp-verify>
    </b-modal>
    <div class="body-wrapperx">
      <div class="body-titlex">
        <h5 style="color:#2284ab">{{title}}</h5>
      </div>
      <div class="body-contentx">
        <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
        <b-alert
          :show="showDismissibleAlert"
          dismissible
          @dismissed="showDismissibleAlert=false"
          :variant="variant"
        >{{alertText}}</b-alert>
        <b-row class="mt-2">
          <b-col style="text-align:right">
            <b-button @click="survey.prevPage()" v-if="!survey.isFirstPage">Previous</b-button>
            <b-button variant="info" @click="survey.nextPage()" v-if="!survey.isLastPage">Next</b-button>
            <b-button
              variant="success"
              @click="survey.completeLastPage()"
              v-if="survey.isLastPage && survey.mode != 'display' && show"
            >Complete</b-button>
            <!-- <b-button variant="success" @click="pdfDownload()" v-if="survey.isLastPage && survey.mode != 'display'">Download PDF</b-button> -->
          </b-col>
        </b-row>
        <div
          style="padding: 10px;
                    border: 2px solid #c4c6be;
                    border-radius: 15px;"
          class="mt-2"
        >
          <survey :survey="survey"></survey>
          <!-- {{survey}} -->
          <hr />
          <b-row class="mt-2">
            <b-col>Page {{survey.currentPageNo + 1}} of {{survey.visiblePageCount}}</b-col>
            <b-col style="text-align:right">
              <b-button @click="survey.prevPage()" v-if="!survey.isFirstPage">Previous</b-button>
              <b-button variant="info" @click="survey.nextPage()" v-if="!survey.isLastPage">Next</b-button>
              <b-button
                variant="success"
                @click="survey.completeLastPage()"
                v-if="survey.isLastPage && survey.mode != 'display' && show"
              >Save</b-button>
              <!-- <b-button variant="success" @click="pdfDownload()" v-if="survey.isLastPage && survey.mode != 'display'">Download PDF</b-button> -->
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </b-container>
</template>
<script>
import apis from "@/apis";
import Spinner from "vue-simple-spinner";
import * as SurveyVue from "survey-vue";
import Bootstrap from "bootstrap";
import "bootstrap/dist/css/bootstrap.css";
import router from "@/router";
import store from "@/store";
import data from "@/data";
import axios from "axios";
import lambda from "@/apis/lambda";
import OtpVerify from "@/components/GuardSurvey/OtpVerify";
import PortalNavbar from "@/components/PortalNavbar";

var Survey = SurveyVue.Survey;
Survey.cssType = "bootstrap";
SurveyVue.defaultBootstrapCss.navigationButton = "btn btn-green";
var survey = new SurveyVue.Model({});

function SaveData(survey, pagenum, iscomplete) {
  let pmtObj = {};

  let surveyJSON = {};
  /*
  pmtObj.pmtPurpose =
    "Registration of Security Guards Working with Private Agency";

  pmtObj.boardId = "00000000-0000-0000-0000-000000000000";
  let SurveyID = store.getters.getRegId;
  let loggeduser = {
    UserId: SurveyID,
    RoleID: 0,
    UserName: survey.data.name,
    EmailID: survey.data.email,
    RegistrationType: 12
  };

  store.dispatch("login", {
    token: "New Token",
    user: loggeduser
  });
  store.dispatch("setPmtObject", pmtObj);
  store.dispatch("setRegistrationDetails", survey.data);
  */
  var payload = {
    SurveyID: "00000000-0000-0000-0000-000000000000",
    SurveyTypeID: 1,
    SurveyDetails: JSON.stringify(survey.data),
    IsPaid: iscomplete,
    PaymentID: "00000000-0000-0000-0000-000000000000"
  };

  let promise = apis.SaveSurvey(payload);
  promise
    .then(response => {
      //console.log('Reponse' ,response);
      if (response.status == 200 && response.body != "Error in Registration") {
        //this.$store.dispatch("setRegID", response.body);
        if (survey.data.BoardRegistration == "No") {
          router.push("/onlinepayment");
        } else {
          alert(
            "आपण दिलेली माहिती संग्रहीत केली आहे. आपल्या माहिती बद्दल धन्यवाद."
          );
          router.push("/");
        }
      }
    })
    .catch(err => {
      console.error(err);
      if (pagenum == -1) {
        pagenum = 0;
      }
      this.survey.currentPage = pagenum;
      //console.log("Reponse", err.body);
      alert("Error");
    });
}

export default {
  components: { Survey, Spinner, OtpVerify, PortalNavbar },
  data() {
    return {
      showModal: true,
      title: "SURVEY OF SECURITY GUARDS WORKING IN SGB MUMBAI",
      survey: survey,
      SurveyID: "00000000-0000-0000-0000-000000000000",
      isLoading: false,
      variant: "success",
      alertText: "",
      showDismissibleAlert: false,
      show: false
    };
  },
  methods: {
    onSubmit() {
      //alert("The results are:" + JSON.stringify(this.survey.data));
    },
    onReset() {},

    async LoadSurvey(mobile, id) {
      this.show = true;
      this.$refs["mdlOtp"].hide();
      this.SurveyID = id;
      this.$store.dispatch("setRegID", id);
      // let surveyJSON = {};
      let surveyJSON = {
        title: "लोकल प्रवासासाठी लागणारी माहिती (फक्त सुरमं मुंबई साठी) ",
        completedHtml: "<h3>THANK YOU!!</h3>",
        pages: [
          {
            name: "page1",
            elements: [
              {
                type: "text",
                name: "Registration No",
                title: "Registration No. (नोंदणी क्रमांक)",
                isRequired: true,
                inputType: "number",
                min: "1",
                max: "64000"
              },
              {
                type: "text",
                name: "MobileNum",
                title: "Mobile No. (मोबाईल क्रमांक)",
                isRequired: true,
                inputType: "number",
                min: "1000000000",
                max: "9999999999"
              },
              {
                type: "dropdown",
                name: "Start Station",
                title: "Start Station (सुरवातीचे स्थानक)",
                isRequired: true,
                choices: [
                  "Airoli (ऐरोली)",
                  "Ambarnath (अंबरनाथ)",
                  "Ambivli (आंबिवली)",
                  "Andheri (अंधेरी)",
                  "Asangaon (आसनगांव)",
                  "Atgaon (आटगांव)",
                  "Badlapur (बदलापूर)",
                  "Baman Dongari (बामणडोंगरी)",
                  "Bandra (वांद्रे)",
                  "Bhandup (भांडुप)",
                  "Bhayandar (भाईंदर)",
                  "Bhivpuri Road (भिवपुरी रोड)",
                  "Bhiwandi Road (भिवंडी रोड)",
                  "Boisar (बोईसर)",
                  "Borivali (बोरिवली)",
                  "Byculla (भायखळा)",
                  "CBD Belapur (सी.बी.डी.बेलापूर)",
                  "Charni Road (चर्नीरोड)",
                  "Chembur (चेंबूर)",
                  "Chhatrapati Shivaji Maharaj Terminus (छत्रपती शिवाजी महाराज टर्मिनस)",
                  "Chinchpokli (चिंचपोकळी)",
                  "Chunabhatti (चुनाभट्टी)",
                  "Churchgate (चर्चगेट)",
                  "Cotton Green (कॉटन ग्रीन)",
                  "Currey Road (करीरोड)",
                  "Dadar (दादर)",
                  "Dahanu Road (डहाणू रोड)",
                  "Dahisar (दहिसर)",
                  "Dativali (दातिवली)",
                  "Diva (दिवा)",
                  "Dockyard Road (डॉकयार्ड रोड)",
                  "Dolavli (डोलवली)",
                  "Dombivli (डोंबिवली)",
                  "Prabhadevi (प्रभादेवी)",
                  "Gavan (गव्हाण)",
                  "Ghansoli (घणसोली)",
                  "Ghatkopar (घाटकोपर)",
                  "Goregaon (गोरेगांव)",
                  "Govandi (गोवंडी)",
                  "Grant Road (ग्रँट रोड)",
                  "Guru Tegh Bahadur Nagar (गुरु तेग बहादूर नगर)",
                  "Jogeshwari (जोगेश्वरी)",
                  "Juchandra (जुचंद्र)",
                  "Juinagar (जुईनगर)",
                  "Kalamboli (कळंबोली)",
                  "Kalwa (कळवा)",
                  "Kalyan (कल्याण)",
                  "Kaman Road (कामण रोड)",
                  "Kandivali (कांदिवली)",
                  "Kanjurmarg (कांजुरमार्ग)",
                  "Karjat (कर्जत)",
                  "Kasara (कसारा)",
                  "Kelavli (केळवली)",
                  "Kelve Road (केळवे रोड)",
                  "Khadavli (खडवली)",
                  "Khandeshwar (खांदेश्वर)",
                  "Khar Road (खार रोड)",
                  "Kharbao (खारबाव)",
                  "Khardi (खर्डी)",
                  "Kharghar (खारघर)",
                  "Kharkopar (खारकोपर)",
                  "Khopoli (खोपोली)",
                  "King's Circle (किंग्जसर्कल)",
                  "Kopar (कोपर)",
                  "Kopar Khairane (कोपरखैरणे)",
                  "Kurla (कुर्ला)",
                  "Lower Parel (लोअर परळ)",
                  "Lowjee (लौजी)",
                  "Mahalaxmi (महालक्ष्मी)",
                  "Mahim (माहीम)",
                  "Malad (मालाड)",
                  "Mankhurd (मानखुर्द)",
                  "Mansarovar (मानसरोवर)",
                  "Marine Lines (मरीन लाईन्स)",
                  "Masjid (मशीद)",
                  "Matunga (माटुंगा)",
                  "Matunga Road (माटुंगा रोड)",
                  "Mira Road (मीरा रोड)",
                  "Mumbai Central (मुंबई सेंट्रल)",
                  "Mulund (मुलुंड)",
                  "Mumbra (मुंब्रा)",
                  "Nahur (नाहूर)",
                  "Naigaon (नायगांव)",
                  "Nallasopara (नालासोपारा)",
                  "Neral (नेरळ)",
                  "Nerul (नेरुळ)",
                  "Navade Road (नावडे रोड)",
                  "Nhava Sheva (न्हावाशेवा)",
                  "Nilaje (निळजे)",
                  "Palghar (पालघर)",
                  "Palasdari (पळसधरी)",
                  "Panvel (पनवेल)",
                  "Parel (परळ)",
                  "Rabale (रबाळे)",
                  "Ram Mandir (राम मंदिर)",
                  "Ranjanpada (रांजणपाडा)",
                  "Roha (रोहे)",
                  "Sagar Sangam (सागरसंगम)",
                  "Sandhurst Road (सॅंडहर्स्ट रोड)",
                  "Sanpada (सानपाडा)",
                  "Santacruz (सांताक्रुझ)",
                  "Seawoods-Darave (सीवूड्स दारावे)",
                  "Saphale (सफाळे)",
                  "Sion (शीव)",
                  "Shahad (शहाड)",
                  "Shelu (शेलू)",
                  "Thansit (तानशेत)",
                  "Targhar (तरघर)",
                  "Thane (ठाणे)",
                  "Thakurli (ठाकुर्ली)",
                  "Titwala (टिटवाळा)",
                  "Turbhe (तुर्भे)",
                  "Ulhasnagar (उल्हासनगर)",
                  "Umbermali (उंबरमाळी)",
                  "Umroli (उमरोळी)",
                  "Uran (उरण)",
                  "Wadala Road (वडाळा रोड)",
                  "Vaitarna (वैतरणा)",
                  "Vangaon (वाणगांव)",
                  "Vangani (वांगणी)",
                  "Vasai Road (वसई रोड)",
                  "Vashi (वाशी)",
                  "Vasind (वाशिंद)",
                  "Vidyavihar (विद्याविहार)",
                  "Vikhroli (विक्रोळी)",
                  "Vile Parle (विलेपार्ले)",
                  "Virar (विरार)",
                  "Vithalwadi (विठ्ठलवाडी)",
                  "Tilak Nagar (टिळकनगर)",
                  "Sewri (शिवडी)",
                  "Taloja (तळोजे पंचानंद)",
                  "Pen (पेण)",
                  "Rasayani (रसायनी)",
                  "Nagothane (नागोठणे)",
                  "Somtane (सोमाटणे)",
                  "Hamrapur (हमरापूर)",
                  "Kasu (कासू)",
                  "Nidi (निडी)",
                  "Apta (आपटा)",
                  "Jite (जिते)",
                  "Chouk (चौक)",
                  "Chikhale (चिखले)",
                  "Mohope (मोहोपे)",
                  "Dighe (दिघे)",
                  "Dronagiri (द्रोणगिरी)"
                ]
              },
              {
                type: "dropdown",
                name: "Destination",
                title: "Destination Station (अंतिम स्थानक)",
                isRequired: true,
                choices: [
                  "Airoli (ऐरोली)",
                  "Ambarnath (अंबरनाथ)",
                  "Ambivli (आंबिवली)",
                  "Andheri (अंधेरी)",
                  "Asangaon (आसनगांव)",
                  "Atgaon (आटगांव)",
                  "Badlapur (बदलापूर)",
                  "Baman Dongari (बामणडोंगरी)",
                  "Bandra (वांद्रे)",
                  "Bhandup (भांडुप)",
                  "Bhayandar (भाईंदर)",
                  "Bhivpuri Road (भिवपुरी रोड)",
                  "Bhiwandi Road (भिवंडी रोड)",
                  "Boisar (बोईसर)",
                  "Borivali (बोरिवली)",
                  "Byculla (भायखळा)",
                  "CBD Belapur (सी.बी.डी.बेलापूर)",
                  "Charni Road (चर्नीरोड)",
                  "Chembur (चेंबूर)",
                  "Chhatrapati Shivaji Maharaj Terminus (छत्रपती शिवाजी महाराज टर्मिनस)",
                  "Chinchpokli (चिंचपोकळी)",
                  "Chunabhatti (चुनाभट्टी)",
                  "Churchgate (चर्चगेट)",
                  "Cotton Green (कॉटन ग्रीन)",
                  "Currey Road (करीरोड)",
                  "Dadar (दादर)",
                  "Dahanu Road (डहाणू रोड)",
                  "Dahisar (दहिसर)",
                  "Dativali (दातिवली)",
                  "Diva (दिवा)",
                  "Dockyard Road (डॉकयार्ड रोड)",
                  "Dolavli (डोलवली)",
                  "Dombivli (डोंबिवली)",
                  "Prabhadevi (प्रभादेवी)",
                  "Gavan (गव्हाण)",
                  "Ghansoli (घणसोली)",
                  "Ghatkopar (घाटकोपर)",
                  "Goregaon (गोरेगांव)",
                  "Govandi (गोवंडी)",
                  "Grant Road (ग्रँट रोड)",
                  "Guru Tegh Bahadur Nagar (गुरु तेग बहादूर नगर)",
                  "Jogeshwari (जोगेश्वरी)",
                  "Juchandra (जुचंद्र)",
                  "Juinagar (जुईनगर)",
                  "Kalamboli (कळंबोली)",
                  "Kalwa (कळवा)",
                  "Kalyan (कल्याण)",
                  "Kaman Road (कामण रोड)",
                  "Kandivali (कांदिवली)",
                  "Kanjurmarg (कांजुरमार्ग)",
                  "Karjat (कर्जत)",
                  "Kasara (कसारा)",
                  "Kelavli (केळवली)",
                  "Kelve Road (केळवे रोड)",
                  "Khadavli (खडवली)",
                  "Khandeshwar (खांदेश्वर)",
                  "Khar Road (खार रोड)",
                  "Kharbao (खारबाव)",
                  "Khardi (खर्डी)",
                  "Kharghar (खारघर)",
                  "Kharkopar (खारकोपर)",
                  "Khopoli (खोपोली)",
                  "King's Circle (किंग्जसर्कल)",
                  "Kopar (कोपर)",
                  "Kopar Khairane (कोपरखैरणे)",
                  "Kurla (कुर्ला)",
                  "Lower Parel (लोअर परळ)",
                  "Lowjee (लौजी)",
                  "Mahalaxmi (महालक्ष्मी)",
                  "Mahim (माहीम)",
                  "Malad (मालाड)",
                  "Mankhurd (मानखुर्द)",
                  "Mansarovar (मानसरोवर)",
                  "Marine Lines (मरीन लाईन्स)",
                  "Masjid (मशीद)",
                  "Matunga (माटुंगा)",
                  "Matunga Road (माटुंगा रोड)",
                  "Mira Road (मीरा रोड)",
                  "Mumbai Central (मुंबई सेंट्रल)",
                  "Mulund (मुलुंड)",
                  "Mumbra (मुंब्रा)",
                  "Nahur (नाहूर)",
                  "Naigaon (नायगांव)",
                  "Nallasopara (नालासोपारा)",
                  "Neral (नेरळ)",
                  "Nerul (नेरुळ)",
                  "Navade Road (नावडे रोड)",
                  "Nhava Sheva (न्हावाशेवा)",
                  "Nilaje (निळजे)",
                  "Palghar (पालघर)",
                  "Palasdari (पळसधरी)",
                  "Panvel (पनवेल)",
                  "Parel (परळ)",
                  "Rabale (रबाळे)",
                  "Ram Mandir (राम मंदिर)",
                  "Ranjanpada (रांजणपाडा)",
                  "Roha (रोहे)",
                  "Sagar Sangam (सागरसंगम)",
                  "Sandhurst Road (सॅंडहर्स्ट रोड)",
                  "Sanpada (सानपाडा)",
                  "Santacruz (सांताक्रुझ)",
                  "Seawoods-Darave (सीवूड्स दारावे)",
                  "Saphale (सफाळे)",
                  "Sion (शीव)",
                  "Shahad (शहाड)",
                  "Shelu (शेलू)",
                  "Thansit (तानशेत)",
                  "Targhar (तरघर)",
                  "Thane (ठाणे)",
                  "Thakurli (ठाकुर्ली)",
                  "Titwala (टिटवाळा)",
                  "Turbhe (तुर्भे)",
                  "Ulhasnagar (उल्हासनगर)",
                  "Umbermali (उंबरमाळी)",
                  "Umroli (उमरोळी)",
                  "Uran (उरण)",
                  "Wadala Road (वडाळा रोड)",
                  "Vaitarna (वैतरणा)",
                  "Vangaon (वाणगांव)",
                  "Vangani (वांगणी)",
                  "Vasai Road (वसई रोड)",
                  "Vashi (वाशी)",
                  "Vasind (वाशिंद)",
                  "Vidyavihar (विद्याविहार)",
                  "Vikhroli (विक्रोळी)",
                  "Vile Parle (विलेपार्ले)",
                  "Virar (विरार)",
                  "Vithalwadi (विठ्ठलवाडी)",
                  "Tilak Nagar (टिळकनगर)",
                  "Sewri (शिवडी)",
                  "Taloja (तळोजे पंचानंद)",
                  "Pen (पेण)",
                  "Rasayani (रसायनी)",
                  "Nagothane (नागोठणे)",
                  "Somtane (सोमाटणे)",
                  "Hamrapur (हमरापूर)",
                  "Kasu (कासू)",
                  "Nidi (निडी)",
                  "Apta (आपटा)",
                  "Jite (जिते)",
                  "Chouk (चौक)",
                  "Chikhale (चिखले)",
                  "Mohope (मोहोपे)",
                  "Dighe (दिघे)",
                  "Dronagiri (द्रोणगिरी)"
                ]
              }
            ],
            description:
              "लोकल प्रवासा साठी लागणार्‍या QR Code साठी सुरक्षा रक्षकांनी खलील माहिती फक्त एकदाच भरावी."
          }
        ]
      };
      /*
      let Promise = apis.getQuestions("1");

      await Promise.then(response => {
        if (response.status == 200) {
          surveyJSON = response.body;
          this.survey = new SurveyVue.Model(surveyJSON);
          this.survey.data = { MobileNum: parseInt(mobile) };
        } else {
          this.survey = new SurveyVue.Model(surveyJSON);
          return;
        }
      }).catch(err => {
        console.error(err);
        return;
      });
      */
      this.survey = new SurveyVue.Model(surveyJSON);
      this.title = "SURVEY OF SECURITY GUARDS";
      this.survey.cssType = "bootstrap";
      this.survey.showNavigationButtons = false;
      this.survey.sendResultOnPageNext = true;

      this.survey.onComplete.add(function(survey, options) {
        survey.clear(false);
        if (survey.mode == "display") {
          survey.currentPage = 0;
          return;
        }
        SaveData(survey, survey.currentPageNo, true);
        //router.push("/agencypayment");
      });

      this.survey.onUploadFiles.add((survey, options) => {
        var userid = id;
        //alert(userid);
        var filetype = options.files[0].type;
        //console.log("Options", options);
        //var filepath = "CourtOrder_." + extn;
        var filepath = options.name + "_" + options.files[0].name;
        let promisefoto = lambda.getSignedURL(userid, filepath, filetype);

        promisefoto
          .then(response => {
            let signedUrl = response;
            var upldoptions = {
              headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": options.files[0].type
              }
            };
            return axios.put(signedUrl, options.files[0], upldoptions);
          })
          .then(res => {
            if (res.status == 200) {
              options.callback(
                "success",
                options.files.map(file => {
                  return {
                    file: file,
                    //content: data[file.name]
                    content:
                      "https://s3.ap-south-1.amazonaws.com/sgbimages/" +
                      userid +
                      "/" +
                      filepath
                  };
                })
              );
            } else {
              this.variant = "warning";
              this.alertText = "Error in uploading Image";
              this.showDismissibleAlert = true;
            }
            this.isLoading = false;
          })
          .catch(err => {
            this.alertText = err.body;
            this.showDismissibleAlert = true;
            this.variant = "danger";

            this.isLoading = false;
          });
      });
    }
  },
  mounted() {
    //let surveyJSON = {};
    //this.survey = new SurveyVue.Model(surveyJSON);
    this.LoadSurvey("9920585347", "00000000-0000-0000-0000-000000000000");
    //this.$refs["mdlOtp"].show();
  }
};
</script>
<style scoped>
.body-wrapperx {
  margin-top: 20px;
  padding-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  border: solid thin #ccc;
  -webkit-box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
  -moz-box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
  box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
}

.body-titlex {
  padding: 15px 25px;
  background: #fcfcfc;
  border-bottom: solid 2px #aaa;
}

.body-contentx {
  padding: 25px 10px;
}
h4 {
  font-size: 1rem !important;
}
h5 {
  font-size: 0.875rem !important;
}
/* .form-controlx {
  font-size: 0.75rem;
} */
/* .btn sv_prev_btn {
  color: "red";
} */
</style>


// WEBPACK FOOTER //
// src/components/GuardSurvey/Survey.vue